import { RestClient } from './RestClient'
import store from 'src/store'

export class NoteClient extends RestClient {
  /**
   * NoteClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/notes`
  }

  /**
   * Update an existing note
   *
   * @param {number} id - Note id
   * @param {Object} data - Note info
   *
   * @returns {AxiosPromise}
   */
  update (id, data) {
    return this.call('patch', `${this.baseUrl}/${id}`, data)
  }

  /**
   * Delete the specified notes
   *
   * @param {(...number|number[])} id - Notes which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...id) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }
}
